import { render, staticRenderFns } from "./CoinsBalancePopup.vue?vue&type=template&id=7ca8ab52&scoped=true&"
import script from "./CoinsBalancePopup.vue?vue&type=script&lang=js&"
export * from "./CoinsBalancePopup.vue?vue&type=script&lang=js&"
import style0 from "./CoinsBalancePopup.vue?vue&type=style&index=0&id=7ca8ab52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca8ab52",
  null
  
)

export default component.exports